<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">
        <h5>Informations</h5>
        <div class="form-group row justify-content-center">
          <app-input [label]="'price'" type="number" [formControl]="form_price" [size]="6"
            suffixIcon="euro"></app-input>
          <app-select [label]="'saleMandate'" [formControl]="form_mandateType" [size]="6" [list]="mandateTypeList"
            [isEnum]="true" enumName="SellingMandateType" [isMultiple]="false" [withNoneItem]="true"></app-select>
        </div>
        <div class="form-group row">
          <app-input [label]="'promotionalText'" type="text" [isTextarea]="true" [formControl]="form_promotionalText"
            size="12"></app-input>
        </div>
        <div class="mb-2">
          <div class="links ml-2">
            <span>Liens internet</span>
            <a (click)="addLinkFormItem()" appTooltip="Ajouter un lien" class="ml-2">
              <mat-icon color="primary" aria-label="Ajouter">add_circle</mat-icon>
            </a>
          </div>
          <div formArrayName="links" *ngFor="let valueForm of form_links.controls; let i = index" class="form-group">
            <div [formGroupName]="i" class="form-group row justify-content-center">
              <app-input [label]="'name'" [formControl]="valueForm.get('name')" [size]="5"></app-input>
              <app-input [label]="'url'" [formControl]="valueForm.get('url')" [size]="6"></app-input>
              <div class="col-1 delete-link">
                <a (click)="removeLinkFormItem(i)" appTooltip="Supprimer le lien">
                  <mat-icon color="primary" aria-label="Supprimer">delete_forever</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        <h5>Dates</h5>
        <div class="form-group row">
          <app-input [label]="'dateOnSale'" type="date" [formControl]="form_dateOnSale"></app-input>
        </div>
        <div class="form-group row">
          <app-input [label]="'dateOffer'" type="date" [formControl]="form_dateOffer"></app-input><app-input
            [label]="'dateAgreement'" type="date" [formControl]="form_dateAgreement"></app-input>
        </div>
        <div class="form-group row">
          <app-input [label]="'dateBankLoanApplication'" type="date"
            [formControl]="form_dateBankLoanApplication"></app-input><app-input [label]="'dateBankLoanObtaining'"
            type="date" [formControl]="form_dateBankLoanObtaining"></app-input>
        </div>
        <div class="form-group row">
          <app-input [label]="'dateSigning'" type="date" [formControl]="form_dateSigning"></app-input>
        </div>
      </form>
    </div>
  </div>
</ng-template>